const SELLING_PLAN_ID_INPUT = document.getElementById('mmSellingPlanId');
const SELLING_PLAN_OPTIONS = document.querySelectorAll('.mm-selling-plan-option');
const CTA_PRICE_OS = document.querySelector('.mm-pf-cta-os');
const CTA_PRICE_SUBSCRIPTION = document.querySelector('.mm-pf-cta-abo');
const SUBSCRIPTION_LABEL = document.querySelector('.mm-rc-subscription-label');
const HAS_SUBSCRIPTION_LAYOUT_WINNER = document.querySelector('.mm-selling-plans-elem.mm-selling-plans-subscription[data-subscription-layout-winner="true"]');
syncVariantsLabels();

/**
 * Prix affiché = allocation Shopify pour (variante #product_id × selling plan coché).
 * Le Liquid seul peut être faux si le JS force un autre selling plan que le méta default.
 */
function mmFormatMoneyEurFromCents(cents) {
  const c = Math.round(Number(cents));
  if (!Number.isFinite(c)) return '';
  if (c % 100 === 0) {
    return (c / 100).toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + '€';
  }
  return (c / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '€';
}

/**
 * Même % que la pastille de la fréquence sélectionnée (DOM), pour aligner le bandeau « Abonnement »
 * sur le rendu Liquid initial qui ne se met pas à jour au changement de plan.
 */
function mmParseSubscriptionRowDiscountPercent(planInput) {
  if (!planInput) return null;
  const hoverRaw = planInput.getAttribute('data-hover-discount-percentage');
  if (hoverRaw != null && String(hoverRaw).trim() !== '') {
    const parsed = Number(hoverRaw);
    if (Number.isFinite(parsed) && parsed > 0) return Math.round(parsed);
  }
  const label = document.querySelector(`label[for="${planInput.id}"]`);
  const promo = label?.querySelector('.mm-variant-promotion');
  if (!promo?.textContent) return null;
  const m = String(promo.textContent).match(/-?\s*(\d+)/);
  if (!m) return null;
  const n = Number(m[1]);
  return Number.isFinite(n) && n > 0 ? Math.round(n) : null;
}

function mmSyncSubscriptionHeaderDiscountBadge() {
  const container = document.querySelector('label[for="subscription"] .mm-rc-option-discount-container');
  if (!container || !document.querySelector('#subscription:checked')) return;

  const longForm = container.querySelector('.mm-rc-option-discount');
  const target = longForm || container.querySelector('p');
  if (!target) return;

  const pct = mmParseSubscriptionRowDiscountPercent(document.querySelector('.mm-selling-plan-option:checked'));

  if (pct == null || pct <= 0) {
    target.style.display = 'none';
    if (typeof target.toggleAttribute === 'function') target.setAttribute('hidden', '');
    return;
  }
  target.removeAttribute('hidden');
  target.style.display = '';

  if (longForm) {
    const savingsLabel = longForm.dataset.savingsLabel || '';
    target.textContent = `-${pct}% ${savingsLabel}`;
  } else {
    target.textContent = `-${pct}%`;
  }
}

window.mmSyncSubscriptionHeaderDiscountBadge = mmSyncSubscriptionHeaderDiscountBadge;

function mmSyncSubscriptionAllocationPrice() {
  const mapEl = document.getElementById('mmSubscriptionPlanPricesByVariant');
  if (!mapEl) return;
  let priceMap = {};
  try {
    priceMap = JSON.parse(mapEl.textContent || '{}');
  } catch (e) {
    return;
  }
  const vidRaw = document.getElementById('product_id')?.value;
  if (vidRaw == null || vidRaw === '') return;
  const vid = String(vidRaw);
  const planInput = document.querySelector('.mm-selling-plan-option:checked');
  if (!planInput) return;
  const planId = String(planInput.value);
  const byVariant = priceMap[vid];
  if (!byVariant || typeof byVariant !== 'object') return;
  let cents = byVariant[planId];
  if (!Number.isFinite(Number(cents))) {
    cents = byVariant[String(Number(planId))];
  }
  if (!Number.isFinite(Number(cents))) return;
  const fmt = mmFormatMoneyEurFromCents(cents);

  const headerEl = document.getElementById('mm-subscription-header-price');
  if (headerEl) headerEl.textContent = fmt;

  const ctaReload = document.querySelector('.mm-pf-cta-abo span.mm-reload');
  if (ctaReload) {
    const s = ctaReload.querySelector('s');
    const sHtml = s ? s.outerHTML : '';
    ctaReload.innerHTML = (sHtml ? sHtml + ' ' : '') + fmt + ' ';
  }

  if (window.mmUpdatePaymentSummary) window.mmUpdatePaymentSummary();
  if (window.mmUpdateUnitPrice) window.mmUpdateUnitPrice();
  requestAnimationFrame(() => {
    if (window.mmUpdateSubscriptionUpsell) window.mmUpdateSubscriptionUpsell();
  });
  
  mmSyncSubscriptionHeaderDiscountBadge();
}

/**
 * En achat unique les fréquences sont décochées : pas de plan coché pour mmSyncSubscriptionAllocationPrice.
 * On affiche quand même le 1er paiement de référence (méta default × variante) depuis le JSON d’allocations.
 */
function mmResolveCentsForPlan(byVariant, planIdRaw) {
  if (!byVariant || typeof byVariant !== 'object' || planIdRaw == null || String(planIdRaw).trim() === '') return NaN;
  const pid = String(planIdRaw).trim();
  let cents = byVariant[pid];
  if (Number.isFinite(Number(cents))) return Number(cents);
  cents = byVariant[String(Number(pid))];
  if (Number.isFinite(Number(cents))) return Number(cents);
  for (const k of Object.keys(byVariant)) {
    if (String(k) === pid || String(Number(k)) === String(Number(pid))) {
      const v = byVariant[k];
      if (Number.isFinite(Number(v))) return Number(v);
    }
  }
  return NaN;
}

/**
 * Même règle que mmSubscriptionMethodChanged (mode abonnement) : avec layout winner,
 * la ligne selling_plan_N est couplée à la Nième variante disponible — pas le seul méta default SKIO.
 */
function mmReferenceSellingPlanIdForOneTime() {
  const wrap = document.querySelector('.mm-selling-plans-elem.mm-selling-plans-subscription');
  const fromData = wrap?.getAttribute('data-mm-default-selling-plan-id')?.trim();
  const fromHidden = document.getElementById('mmDefaultSellingPlanIdRef')?.value?.trim();
  const fallbackPlanId = fromData || fromHidden;

  if (!wrap || wrap.getAttribute('data-subscription-layout-winner') !== 'true') {
    return fallbackPlanId || '';
  }

  let availableVariants = document.querySelectorAll('.mm-product-variant-picker-container input[type="radio"]:not([disabled])');
  let selectedVariant = document.querySelector('.mm-product-variant-picker-container input[type="radio"]:checked');
  if (!availableVariants.length || !selectedVariant) {
    availableVariants = document.querySelectorAll('.mm-selling-plans-options-inputs-bis input[type="radio"]:not([disabled])');
    selectedVariant = document.querySelector('.mm-selling-plans-options-inputs-bis input[type="radio"]:checked');
  }
  const idx = Array.from(availableVariants).indexOf(selectedVariant);
  if (idx < 0) {
    return fallbackPlanId || '';
  }
  const planInput = document.getElementById('selling_plan_' + (idx + 1));
  const planFromVariantSlot = planInput?.value?.trim();
  return planFromVariantSlot || fallbackPlanId || '';
}

function mmRestoreSubscriptionHeaderReferencePrice() {
  if (!document.querySelector('#one_time:checked')) return;
  const wrap = document.querySelector('.mm-selling-plans-elem.mm-selling-plans-subscription');
  const fromHidden = document.getElementById('mmDefaultSellingPlanIdRef')?.value?.trim();
  const referencePlanId = mmReferenceSellingPlanIdForOneTime();
  const mapEl = document.getElementById('mmSubscriptionPlanPricesByVariant');
  const headerEl = document.getElementById('mm-subscription-header-price');
  const vidRaw = document.getElementById('product_id')?.value;
  if (!mapEl || !headerEl || vidRaw == null || vidRaw === '') return;
  let priceMap = {};
  try {
    priceMap = JSON.parse(mapEl.textContent || '{}');
  } catch (e) {
    return;
  }
  const vid = String(vidRaw);
  const byVariant = priceMap[vid];
  if (!byVariant || typeof byVariant !== 'object') return;
  let cents = mmResolveCentsForPlan(byVariant, referencePlanId);
  if (!Number.isFinite(cents) && fromHidden) {
    cents = mmResolveCentsForPlan(byVariant, fromHidden);
  }
  if (!Number.isFinite(cents) && wrap?.getAttribute('data-mm-default-selling-plan-id')?.trim()) {
    cents = mmResolveCentsForPlan(byVariant, wrap.getAttribute('data-mm-default-selling-plan-id').trim());
  }
  if (!Number.isFinite(cents)) return;
  headerEl.textContent = mmFormatMoneyEurFromCents(cents);
}

window.mmSyncSubscriptionAllocationPrice = mmSyncSubscriptionAllocationPrice;
window.mmFormatMoneyEurFromCents = mmFormatMoneyEurFromCents;
window.mmRestoreSubscriptionHeaderReferencePrice = mmRestoreSubscriptionHeaderReferencePrice;

function mmSyncBundleOneTimeRowState() {
  const shot = document.querySelector('.mm-selling-plans-one-shot');
  if (!(shot instanceof HTMLElement)) return;
  shot.classList.toggle('mm-bundle-one-time--selected', !!document.querySelector('#one_time:checked'));
}

function mmSubscriptionMethodChanged(selected_selling_method) {
  const method = selected_selling_method.value;

  if (method == 'one_time') {
    if (window.mmSetHoverImageDiscountSource) window.mmSetHoverImageDiscountSource('one_time');
    SELLING_PLAN_ID_INPUT.value = '';
    SELLING_PLAN_OPTIONS.forEach(function (sellingPlanOption) {
      sellingPlanOption.checked = false;
    });
    if (CTA_PRICE_OS) CTA_PRICE_OS.style.display = 'inline-block';
    if (CTA_PRICE_SUBSCRIPTION) CTA_PRICE_SUBSCRIPTION.style.display = 'none';
    if (SUBSCRIPTION_LABEL) SUBSCRIPTION_LABEL.classList.remove('mm-open');
    syncVariantsLabelsBis();
    mmRestoreSubscriptionHeaderReferencePrice();
    if (window.mmUpdateUnitPrice) window.mmUpdateUnitPrice();
    if (window.mmUpdateSubscriptionUpsell) window.mmUpdateSubscriptionUpsell();
    if (window.mmSyncHoverSubscriptionDiscountBadge) window.mmSyncHoverSubscriptionDiscountBadge();
    mmSyncBundleOneTimeRowState();
    if (window.mmUpdateHoverImageDiscountBadge) window.mmUpdateHoverImageDiscountBadge();
  } else {
    const plan_selected = document.querySelector('.mm-selling-plan-option:checked');
    if (plan_selected) {
      SELLING_PLAN_ID_INPUT.value = plan_selected.value;
    } else {
      SELLING_PLAN_OPTIONS[0].checked = true;
      SELLING_PLAN_ID_INPUT.value = SELLING_PLAN_OPTIONS[0].value;
    }
    const availableVariants = document.querySelectorAll('.mm-product-variant-picker-container input[type="radio"]:not([disabled])');
    const selectedVariant = document.querySelector('.mm-product-variant-picker-container input[type="radio"]:checked');
    const selectedVariantIndex = Array.from(availableVariants).indexOf(selectedVariant);
    const selectedSellingPlan = document.querySelector(`.mm-selling-plans-elem label[for="selling_plan_${selectedVariantIndex + 1}"]`);
    if (selectedSellingPlan) selectedSellingPlan.click();
    if (CTA_PRICE_OS) CTA_PRICE_OS.style.display = 'none';
    if (CTA_PRICE_SUBSCRIPTION) CTA_PRICE_SUBSCRIPTION.style.display = 'inline-block';
    if (SUBSCRIPTION_LABEL) SUBSCRIPTION_LABEL.classList.add('mm-open');
    if (window.mmSetHoverImageDiscountSource) window.mmSetHoverImageDiscountSource('subscription');
    mmSyncSubscriptionAllocationPrice();
    if (window.mmSyncHoverSubscriptionDiscountBadge) window.mmSyncHoverSubscriptionDiscountBadge();
    mmSyncBundleOneTimeRowState();
    if (window.mmUpdateHoverImageDiscountBadge) window.mmUpdateHoverImageDiscountBadge();
  }
}

function mmSubscriptionPlanChanged(selected_selling_plan) {
  if (window.mmSetHoverImageDiscountSource) window.mmSetHoverImageDiscountSource('subscription');
  const selectedOptionIndex = Array.from(SELLING_PLAN_OPTIONS).indexOf(selected_selling_plan);
  const VARIANTS_INPUTS_LABELS = document.querySelectorAll('.mm-product-variant-picker-container label');
  if (VARIANTS_INPUTS_LABELS.length > 1 && HAS_SUBSCRIPTION_LAYOUT_WINNER) {
    VARIANTS_INPUTS_LABELS[selectedOptionIndex].click();
  }
  const selected_selling_plan_id = selected_selling_plan.value;

  SELLING_PLAN_ID_INPUT.value = selected_selling_plan_id;

  requestAnimationFrame(() => {
    if (!(VARIANTS_INPUTS_LABELS.length > 1 && HAS_SUBSCRIPTION_LAYOUT_WINNER)) {
      mmSyncSubscriptionAllocationPrice();
    }
    mmSyncSubscriptionHeaderDiscountBadge();
    if (window.mmUpdateUnitPrice) window.mmUpdateUnitPrice();
    if (window.mmSyncHoverSubscriptionDiscountBadge) window.mmSyncHoverSubscriptionDiscountBadge();
    if (window.mmUpdateHoverImageDiscountBadge) window.mmUpdateHoverImageDiscountBadge();
    mmSyncBundleOneTimeRowState();
  });
}

function syncVariantsLabels() {
  const VARIANTS_INPUTS_LABELS_BIS = document.querySelectorAll('.mm-selling-plans-options-inputs-bis label');
  if (VARIANTS_INPUTS_LABELS_BIS.length > 0) {
    VARIANTS_INPUTS_LABELS_BIS.forEach(function (variantInputLabel, index) {
      variantInputLabel.addEventListener('click', function () {
        const VARIANTS_INPUTS_LABELS = document.querySelectorAll('.mm-product-variant-picker-container label');
        VARIANTS_INPUTS_LABELS[index].click();
      });
    });
  }
}

function syncVariantsLabelsBis() {
  const availableVariants = document.querySelectorAll('.mm-product-variant-picker-container input[type="radio"]:not([disabled])');
  const VARIANTS_INPUTS_LABELS_BIS = document.querySelectorAll('.mm-selling-plans-options-inputs-bis label');
  const selectedVariant = document.querySelector('.mm-product-variant-picker-container input[type="radio"]:checked');
  const selectedVariantIndex = Array.from(availableVariants).indexOf(selectedVariant);
  if (VARIANTS_INPUTS_LABELS_BIS.length > 1) {
    VARIANTS_INPUTS_LABELS_BIS[selectedVariantIndex].click();
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const savedScrollX = window.scrollX;
  const savedScrollY = window.scrollY;

  const selectedSellingMethod = document.querySelector('input[name="purchase_option"]:checked');
  const availableVariants = document.querySelectorAll('.mm-product-variant-picker-container input[type="radio"]:not([disabled])');
  const selectedVariant = document.querySelector('.mm-product-variant-picker-container input[type="radio"]:checked');
  const selectedVariantIndex = Array.from(availableVariants).indexOf(selectedVariant);
  const selectedSellingPlan = document.querySelector(`.mm-selling-plans-elem label[for="selling_plan_${selectedVariantIndex + 1}"]`);
  if (selectedSellingPlan) selectedSellingPlan.click();
  if (selectedSellingMethod) {
    mmSubscriptionMethodChanged(selectedSellingMethod);
  } else {
    mmSyncSubscriptionAllocationPrice();
    mmSyncBundleOneTimeRowState();
    if (window.mmUpdateHoverImageDiscountBadge) window.mmUpdateHoverImageDiscountBadge();
  }

  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      window.scrollTo(savedScrollX, savedScrollY);
      mmSyncSubscriptionHeaderDiscountBadge();
      if (typeof window.mmUpdateHoverImageDiscountBadge === 'function') window.mmUpdateHoverImageDiscountBadge();
      mmSyncBundleOneTimeRowState();
    });
  });
});
